export default {
    appTitle: "Kuusakoski Weee",
};
